import { faRemove } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { Targeting } from '@feathr/blackbox';
import { Button, Pill } from '@feathr/components';

import * as styles from './SelectedTargetings.css';

interface IProps {
  targeting: Targeting;
  removeTargeting: (targeting: Targeting) => void;
  name: string;
}

function RemovableTargeting({ targeting, removeTargeting, name }: Readonly<IProps>): JSX.Element {
  function handleRemoveTargeting(): void {
    removeTargeting(targeting);
  }

  return (
    <Pill
      className={styles.pill}
      suffix={
        <Button onClick={handleRemoveTargeting} type={'naked'}>
          <FontAwesomeIcon className={'icon'} icon={faRemove} />
        </Button>
      }
      theme={'sky'}
    >
      {name}
    </Pill>
  );
}

export default observer(RemovableTargeting);
